import { initReviewWidget, SUPPORTED_LOCALES, SupportedLocale } from "../review_widget/base"

const widgetContainerSelector = '.buenno-embed-answers-widget';

function getAssetHost(): string {
  if (window.buenno && window.buenno.assetHostOverride) {
    return window.buenno.assetHostOverride;
  }

  return 'https://cdn.buenno.fi';
}

function normalizeLocale(locale?: string): SupportedLocale {
  return SUPPORTED_LOCALES.includes((locale || '').toLowerCase() as SupportedLocale)
    ? (locale || '').toLowerCase() as SupportedLocale
    : 'en';
}

function setupWidget(container: HTMLElement, contentIdentifier?: string, locale?: string, preview: boolean = false) {
  const cid = contentIdentifier || container.getAttribute('data-content-identifier');
  const loc = normalizeLocale(locale || container.getAttribute('data-locale') || 'en');

  if (!cid) {
    console.warn("Missing contentIdentifier for review widget");
    return;
  }

  fetchWidgetData(cid, loc, preview)
    .then((data) => {
      initReviewWidget(container, data);
    })
    .catch((err) => {
      console.error("Failed to load review widget:", err);
    });
}

function fetchWidgetData(contentIdentifier: string, locale: string = 'en', preview: boolean = false) {
  const params = new URLSearchParams({
    content_identifier: contentIdentifier,
    locale: locale,
    ...(preview ? { preview: 'true' } : {})
  });

  /**
   * Note: Currently the asset_host is set on build time, and promoting staging->production would
   * use the wrong one here.
   * Now we have hardcoded the production CDN URL. @TODO: Replace this with dynamic asset_host once Heroku
   * promoting is fixed.
   *
   * Can be overridden for testing in staging using data-asset-host attribute on the widget container.
   * */
  return fetch(`${getAssetHost()}/widgets/reviews/data?${params.toString()}`)
    .then((res) => {
      if (!res.ok) throw new Error(`Failed to fetch: ${res.statusText}`);
      return res.json();
    });
}

const container = document.querySelector(widgetContainerSelector) as HTMLElement;
if (container) {
  setupWidget(container);
} else {
  console.warn('Review widget container not found.');
}

interface WidgetReloadConfig {
  container?: HTMLElement;
  contentIdentifier?: string;
  locale?: string;
  preview?: boolean;
}

(window as any).buenno = {
  ...(window as any).buenno,
  
  widgetReload: (config: WidgetReloadConfig = {}) => {
    config = config || {};

    const container = config.container ?? document.querySelector(widgetContainerSelector);
    if (!container) {
      console.warn('buenno.widgetReload: widget container not found.');
      return;
    }

    const contentIdentifier = config.contentIdentifier ?? container?.getAttribute('data-content-identifier');
    const locale = config.locale ?? container?.getAttribute('data-locale');
    const preview = config.preview ?? container?.getAttribute('data-preview') === 'true';

    if (!contentIdentifier) {
      console.warn('buenno.widgetReload: contentIdentifier is not set.');
      return;
    }

    setupWidget(container, contentIdentifier, locale, preview);
  }
};